/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { goodLuckCoreEntitiesOrganizationSchema } from "./organizationSchema.ts";
import { goodLuckCoreEntitiesUserSchema } from "./userSchema.ts";
import { z } from "zod/v4";

export const goodLuckCoreEntitiesOrganizationStreamerSchema = z.object({
  id: z.optional(z.uuid()),
  organizationId: z.uuid(),
  get organization() {
    return goodLuckCoreEntitiesOrganizationSchema.optional();
  },
  twitchChannel: z.string().min(1).max(100),
  displayName: z.string().max(100).nullish(),
  userId: z.string().nullish(),
  get user() {
    return goodLuckCoreEntitiesUserSchema.optional();
  },
  addedAt: z.optional(z.iso.datetime()),
  isVisible: z.optional(z.boolean()),
  displayOrder: z.optional(z.int()),
});
